import {useCallback, useState} from 'react'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

type BannerType = 'trustpilot' | 'trustSurvey'

export const useSearchResultsBanner = () => {
  const {search} = useBrandCapabilities()
  const {hasTrustBanners} = search
  const [canRenderTrustSurvey, setCanRenderTrustSurvey] =
    useState(hasTrustBanners)

  const isBannerEnabled = useCallback(
    (type: BannerType, index: number) => {
      switch (type) {
        case 'trustpilot':
          return hasTrustBanners && index === 1
        case 'trustSurvey':
          return hasTrustBanners && canRenderTrustSurvey && index === 1
        default:
          return false
      }
    },
    [canRenderTrustSurvey, hasTrustBanners]
  )

  return {
    isBannerEnabled,
    onTrustSurveyVisibilityChange: setCanRenderTrustSurvey
  }
}
